import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=0b5065ca&"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js&"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5065ca')) {
      api.createRecord('0b5065ca', component.options)
    } else {
      api.reload('0b5065ca', component.options)
    }
    module.hot.accept("./CalendarSidebar.vue?vue&type=template&id=0b5065ca&", function () {
      api.rerender('0b5065ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-sidebar/CalendarSidebar.vue"
export default component.exports